import { ChatMarkdown } from "@/core/components/chat-markdown";
import type { Rules } from "./types";

export const RulesView = ({
  title,
  rules,
  empty,
}: {
  title: string;
  rules: Rules | null;
  empty: string;
}) => (
  <section className="min-w-0 space-y-3 p-4">
    <h2 className="font-semibold">{title}</h2>
    {rules?.rules ? (
      <ChatMarkdown>{rules.rules}</ChatMarkdown>
    ) : (
      <p className="text-sm text-secondary-text">{empty}</p>
    )}
  </section>
);
